import { Product, ProductRecommendation, ProductRecommendationErrorTypes } from '@app/core/models';
import { Pathology } from '@app/core/models/pathology';
import { SmartRecoStep, steps } from '../smart-reco-step';
import { NutritionalAssessment } from '@app/shared/components/nutrients-list/nutrients.js';

export interface SmartRecoState {
  pathologies: Pathology[] | null;
  recommendation: {
    products: ProductRecommendation[];
  } | null;
  nutritionalAssessment: NutritionalAssessment | null;
  nutritionalAssessmentHasError: boolean;
  nutritionalAssessmentLoading: boolean;
  recommendationErrorType: ProductRecommendationErrorTypes | null;
  recommendationSessionIdError: string | null;
  notRecommendedProduct: ProductRecommendation | null;
  relatedWetProducts: Product[];
  catalogProducts: Product[];
  steps: SmartRecoStep[];
  step: SmartRecoStep;
  lastStepBeforeAllowance: SmartRecoStep | null;
  retryCount: number;
  productsCostPerDay: number[];
  notRecommendedProductCostPerDay: number;
  isIndividualisSelected: boolean;
}

export const initialSmartRecoState: SmartRecoState = {
  pathologies: [],
  recommendation: null,
  nutritionalAssessment: null,
  nutritionalAssessmentHasError: false,
  nutritionalAssessmentLoading: false,
  recommendationErrorType: null,
  recommendationSessionIdError: null,
  notRecommendedProduct: null,
  relatedWetProducts: null,
  catalogProducts: [],
  steps,
  step: steps[0],
  lastStepBeforeAllowance: null,
  retryCount: 0,
  productsCostPerDay: null,
  notRecommendedProductCostPerDay: null,
  isIndividualisSelected: false,
};
